import React from "react";
import { Icon } from '@fluentui/react/lib/Icon';
import { IPersonaSharedProps, PersonaInitialsColor, Persona, PersonaSize } from '@fluentui/react/lib/Persona';

const PowerAppOwnerChange= ({currentOwner, newOwner}) => {
    
    const mapOwnerForPersona = (user) => {
        return user ? user.displayName : 'None';
    }

    return (
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", margin: "auto"}}>      
            <Persona
                {...sharedProps}
                secondaryText="Current Owner"
                text={mapOwnerForPersona(currentOwner)}
            />
            <Icon iconName="Down" style={{ paddingTop: "5px", paddingBottom: "5px" }}/>
            <Persona
                {...sharedProps}
                secondaryText="New Owner"
                text={mapOwnerForPersona(newOwner)}
            />
        </div>
    );
}

const sharedProps: IPersonaSharedProps = {
    showSecondaryText: true,
    initialsColor: PersonaInitialsColor.darkBlue,
    size: PersonaSize.size32
};

export default PowerAppOwnerChange


// WEBPACK FOOTER //
// ./src/components/ManageCenter/ChangeValues/PowerAppOwnerChange.js